/**
 * Category definitions with display names, colors, and SVG icon paths.
 */
export const CATEGORIES = {
  roads: {
    id: 'roads',
    name: 'Дороги',
    nameEn: 'Roads',
    color: '#f97316',
    colorLight: 'rgba(249, 115, 22, 0.15)',
    icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 19L8 5"/><path d="M16 5l4 14"/><path d="M12 6v2"/><path d="M12 12v2"/><path d="M12 18v2"/></svg>`,
  },
  trash: {
    id: 'trash',
    name: 'Мусор',
    nameEn: 'Trash',
    color: '#22c55e',
    colorLight: 'rgba(34, 197, 94, 0.15)',
    icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18"/><path d="M8 6V4a2 2 0 012-2h4a2 2 0 012 2v2"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/></svg>`,
  },
  safety: {
    id: 'safety',
    name: 'Безопасность',
    nameEn: 'Safety',
    color: '#ef4444',
    colorLight: 'rgba(239, 68, 68, 0.15)',
    icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>`,
  },
  lighting: {
    id: 'lighting',
    name: 'Освещение',
    nameEn: 'Lighting',
    color: '#eab308',
    colorLight: 'rgba(234, 179, 8, 0.15)',
    icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 18h6"/><path d="M10 22h4"/><path d="M12 2a7 7 0 00-4 12.7V17h8v-2.3A7 7 0 0012 2z"/></svg>`,
  },
  pollution: {
    id: 'pollution',
    name: 'Загрязнение',
    nameEn: 'Pollution',
    color: '#8b5cf6',
    colorLight: 'rgba(139, 92, 246, 0.15)',
    icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M17.5 19a2.5 2.5 0 100-5h-.6A7 7 0 104 14.3"/><path d="M8 19h9.5"/></svg>`,
  },
  noise: {
    id: 'noise',
    name: 'Шум',
    nameEn: 'Noise',
    color: '#ec4899',
    colorLight: 'rgba(236, 72, 153, 0.15)',
    icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 5L6 9H2v6h4l5 4V5z"/><path d="M19.07 4.93a10 10 0 010 14.14"/><path d="M15.54 8.46a5 5 0 010 7.07"/></svg>`,
  },
  transport: {
    id: 'transport',
    name: 'Транспорт',
    nameEn: 'Transport',
    color: '#06b6d4',
    colorLight: 'rgba(6, 182, 212, 0.15)',
    icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="3" width="18" height="14" rx="2"/><path d="M7 21h10"/><path d="M12 17v4"/><circle cx="7.5" cy="17.5" r="1.5"/><circle cx="16.5" cy="17.5" r="1.5"/></svg>`,
  },
  other: {
    id: 'other',
    name: 'Другое',
    nameEn: 'Other',
    color: '#64748b',
    colorLight: 'rgba(100, 116, 139, 0.15)',
    icon: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="1"/><circle cx="19" cy="12" r="1"/><circle cx="5" cy="12" r="1"/></svg>`,
  },
};

export const CATEGORY_LIST = Object.values(CATEGORIES);

export function getCategoryById(id) {
  return CATEGORIES[id] || CATEGORIES.other;
}

export function getCategoryColor(id) {
  return (CATEGORIES[id] || CATEGORIES.other).color;
}
